<form-wizard (onStepChanged)="onStepChanged($event)" [doNext]='triggerStepChange'>
  <app-spinner [isBusy]="showSpinner"></app-spinner>
  <app-modal (onOkToParent)='okCloseButtonClick(true)' (onCloseToParent)='okCloseButtonClick(false)' *ngIf='openModal'
    [dialogTitle]="dialogTitle" [dialogTextLine1]="dialogTextLine1" [dialogTextLine2]="dialogTextLine2"
    [primaryButtonText]="'OK'" [secondaryButtonText]="cancelButton"></app-modal>

  <wizard-step [title]="'Step 1'" [isValid]="true" (onNext)="onStep1Next($event)" [showNext]='stepOneDone' >
    <div *ngIf="isQuickAudit">
      <h1 id="step1Heading">Step 1: Basic Information </h1>
      <div class="wizard">
        <app-qa-select-company (RfpAccountChange)="rfpAccountidUpdate($event)" [isQuickAuditRerun]="isQuickAuditRerun" ></app-qa-select-company>

        <div class="upload-stats">
          <div>{{propertyCountDescription}} {{propertyCount}}</div>
          <app-alert></app-alert>
        </div>

      </div>
    </div>
    <div *ngIf="!isQuickAudit">
      <h1>Step 1: Import Excel Job File</h1>
      <div>
        <form #userForm="ngForm" id="userForm">
          <div class="k-widget k-upload k-header k-dropzone">
            <div role="button" class="cvt-primary k-button k-upload-button" aria-label="Select files..." tabindex="0">
              <input #fileItem="ngModel" type="file" autocomplete="off" id="asdffiles" name="asdffiles"
                [(ngModel)]="myFiles" autocomplete="off" accept="*/*" (change)="onFileSelected($event)" />
              <span>Select files...</span>
            </div>
            <ul class="k-upload-files k-reset" *ngIf="selectedFileToUpload">
              <li class="k-file k-file-success" tabindex="-1">

                <div class="k-file-single ng-tns-c13-0">
                  <span class="k-progress ng-trigger ng-trigger-progressState" style="width: 100%; opacity: 0;"></span>
                  <span class="k-file-extension-wrapper ng-tns-c13-0">
                    <span class="k-file-extension">xls</span>
                    <span class="k-file-state"></span>
                  </span>
                  <span class="k-file-name-size-wrapper ng-tns-c13-0">
                    <span class="k-file-name" [title]="selectedFileToUpload" [innerText]="selectedFileToUpload"></span>
                    <span class="k-file-size" [innerText]="uploadFilesize"></span>
                  </span>

                  <div class="ng-tns-c13-0">
                    <strong class="k-upload-status">
                      <button type="button" class="k-button k-upload-action" tabindex="-1"
                        (click)="onRemoveSelectedFile()">
                        <span class="k-icon k-delete k-i-x" aria-label="Remove" title="Remove">
                        </span>
                      </button>
                    </strong>
                  </div>
                </div>
              </li>

            </ul>
          </div>
        </form>
        <div class="upload-stats">
          <app-alert></app-alert>
          <div *ngIf="selectedFileToUpload">
            <div class="upload-stats-title">Total Property Count to be Audited: </div><span
              [innerText]="uploadStatistics.TotalPropertyCount"></span>
          </div>
          <div *ngIf="thisIsARerun">
            <div class="upload-stats-title">Previous Audit Matched To Account: </div><span
              [innerText]="uploadStatistics.PreviousAuditTitle"></span> <span
              [innerText]="uploadStatistics.PreviousAuditID"></span>
          </div>
          <div *ngIf="thisIsARerun">
            <div class="upload-stats-title">Property Count That Was Matched As Loaded And Will Not Be Rerun With This
              Job: </div><span [innerText]="uploadStatistics.MatchPropertyCount"></span>
          </div>
          <div *ngIf="thisIsARerun">
            <div class="upload-stats-title"></div><span [innerText]=""></span>
          </div>
        </div>
      </div>
    </div>
     <div id="gds-settings" *ngIf="showGds">
      <h5>GDS Settings</h5>
      <div>
        <div>
          <ngl-checkbox label="Amadeus" id="chkAuditAmadeus" *ngIf="amadeusAvailable">
            <input ngl type="checkbox" name="Amadeus" [disabled]="disableAuditAmadeus" [(ngModel)]="editedAudit.AuditAmadeus"
            />
          </ngl-checkbox>
        </div>
        <div>
          <ngl-checkbox label="Apollo" id="chkAuditApollo" *ngIf="apolloAvailable">
            <input ngl type="checkbox" name="Apollo" [disabled]="disableAuditApollo" [(ngModel)]="editedAudit.AuditApollo"
            />
          </ngl-checkbox>
        </div>
        <div>
          <ngl-checkbox label="Galileo" id="chkAuditGalileo" *ngIf="galileoAvailable">
            <input ngl type="checkbox" name="Galileo" [disabled]="disableAuditGalileo" [(ngModel)]="editedAudit.AuditGalileo"
            />
          </ngl-checkbox>
        </div>
        <div>
          <ngl-checkbox label="Sabre" id="chkAuditSabre" *ngIf="sabreAvailable">
            <input ngl type="checkbox" name="Sabre" [disabled]="disableAuditSabre" [(ngModel)]="editedAudit.AuditSabre"
            />
          </ngl-checkbox>
        </div>
        <div>
          <ngl-checkbox label="Worldspan" id="chkAuditWorldspan" *ngIf="worldspanAvailable">
            <input ngl type="checkbox" name="Worldspan" [disabled]="disableAuditWorldspan" [(ngModel)]="editedAudit.AuditWorldspan"
            />
          </ngl-checkbox>
        </div>
      </div>
    </div>
  </wizard-step>
  <wizard-step [title]="'Step2'" [showNext]="step2.showNext" [showPrev]="step2.showPrev" (onNext)="onStep2Next($event)" (onPrev)="onStep2Prev($event)">
    <h1>Step 2: Verify Imported Properties</h1>
    <app-property-edit [toConfirmDlg]="this"></app-property-edit>
  </wizard-step>
  <wizard-step [title]="'Step3'" [showNext]="step3.showNext" [showPrev]="step3.showPrev" (onNext)="onStep3Next($event)"
    (onComplete)="onComplete($event)" isDisabled=true>
    <h1>Step 3: Adjust Processing Settings</h1>
    <app-process-settings [toConfirmDlg]="this" [isQuickAudit]="isQuickAudit" (verifyEmailAdd)=ShowNextOrSubmit($event)>
    </app-process-settings>
  </wizard-step>

  <wizard-step id="step4" [title]="'Step4'" (onComplete)="onComplete($event)"  [hidden]=!enableStep4 >
    <div *ngIf="enableStep4">
      <h1 id="step4Heading">Step 4: Email Verification</h1>
      <div class="wizard">
        <app-qa-email-verification></app-qa-email-verification>
      </div>
    </div>
  </wizard-step>

</form-wizard>
